export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    route: 'app-dashboard',
    action: 'read',
    resource: 'dashboard',
  },
]
